import { AvailabilityHtmlId } from '@vfde-sails/availability';

export enum AppContainerId {
    APP = 'fixnet-app-wrapper',
    ERROR = 'fixnet-error-wrapper',
    APP_LOADING = 'fixnet-loading-spinner',
    OVERLAY_LOADING = 'fixnet-overlay-loading-spinner',
    OVERLAY = 'fixnet-overlay',
    GIGAKOMBI_CONTAINER = 'fixnet-gigakombi-container',
    GIGAKOMBI_PICKER = 'fixnet-gigakombi-picker',
    GIGAKOMBI_INFORMATION = 'fixnet-gigakombi-information',
    QUALITY_SEAL = 'fixnet-quality-seal',
    FOOTNOTE_ACCORDION = 'fixnet-footnote-accordion',
    FAQ_ACCORDION = 'fixnet-faq-accordion',
    LEGAL_ACCORDION = 'fixnet-sh-accordion',
    TV_TABS = 'fixnet-tv-tabs',
    HIGHLIGHT_CAROUSEL = 'fixnet-highlight-carousel',
    RELATED_OFFERS = 'fixnet-related-links-offers',
    RELATED_LINKS = 'fixnet-related-links',
    DEVICE_TABS = 'fixnet-device-tabs',
    DEVICE_TABS_HOMEBOX_BUTTON = 'control-home-box',
    DEVICE_TABS_SOUNDBOX_BUTTON = 'control-home-sound-box',
    DEVICE_SOUNDBOX_CAROUSEL = 'content-home-sound-box',
    DEVICE_HOMEBOX_CAROUSEL = 'content-home-box',
    ADDRESS_BLOCK = 'fixnet-checked-address-wrapper',
    TV_CONNECT_FOOTNOTE = 'fixnet-tv-connect-footnote'
}

export enum ProductContainerId {
    PROMOTIONAL_CARD = 'fixnet-promotional-card',
    SUMMARY_CARD = 'fixnet-offer-summary-card',
    PRODUCT_PICKER = 'fixnet-product-picker',
    OPTION_PICKER = 'fixnet-option-picker',
    OPTION_BENEFIT = 'fixnet-option-benefit',
    DEVICE_PICKER = 'fixnet-device-picker',
    PRODUCT_BENEFITS_LIST = 'fixnet-vertical-list',
    DEVICE_BENEFITS_LIST = 'fixnet-checkmark-list'
}

export enum AddressValidationId {
    ADDRESS = 'fixnet-checked-address',
    DELETE_BUTTON = 'fixnet-delete-address-button',
    CHANGE_BUTTON = 'fixnet-avc-result-change-button',
    RESULT_ADDRESS = 'fixnet-avc-result-address-text',
    NOTIFICATION = 'fixnet-avc-result-notification',
    BUTTON = 'fixnet-avc-result-button',
    ALTERNATIVE = 'fixnet-avc-result-alternative',
    RESULT_WRAPPER = 'fixnet-avc-result-container',
    MORE_INFO_BUTTON = 'fixnet-more-info-button',
    MORE_INFO_HEADLINE = 'fixnet-more-info-headline',
    MORE_INFO_SUBLINE = 'fixnet-more-info-subline',
}

export type HtmlId = AppContainerId
    | ProductContainerId
    | AddressValidationId
    | AvailabilityHtmlId
    | CustomerInfoId;

export enum NameSpace {
    APP = 'GIGA_TV/APP',
    ADDRESS_VALIDATION = 'GIGA_TV/ADDRESS_VALIDATION'
}

export enum HttpStatus {
    UNAUTHORIZED = 401,
    BAD_REQUEST = 400,
    INTERNAL = 500,
}

export enum OverlayView {
    AVAILABILITY_FORM = 'fixnet-avc-form-container',
    AVAILABILITY_RESULT = 'fixnet-avc-result-container',
    MORE_INFO = 'fixnet-more-info-container',
}

export enum Domain {
    ZH = 'https://zuhauseplus.vodafone.de',
    VF = 'https://eweb8.vfd2-testnet.de',
}

export enum Endpoint {
    JARVIS = '/api/jarvis/zuhauseplus/v1/getProductDetails',
    OPTION_PAGE = '/optionen/',
    LOGIN = '/meinvodafone/account/login',
}

export enum ProductType {
    CABLE = 'cable',
    NET = 'net',
}

export enum Option {
    PREMIUM = 'premium',
    NETFLIX = 'netflix',
    NONE = 'none',
}

export enum Device {
    SOUNDBOX = 'soundBox',
    HOMEBOX = 'homeBox',
}

export enum Gigakombi {
    INTERNET = 'internet',
    PHONE = 'mobile',
    INTERNET_MOBILE = 'internetMobile',
    NONE = 'false',
}

export enum QueryNames {
    PRODUCT = 'product',
    GIGAKOMBI = 'gigakombi',
    YOUNG = 'young',
    FF = 'ffv2',
    BASKET = 'vfBasket',
    OPTION = 'vfOptionBasket',
    AFTER_LOGIN_TARGET = 'targetURL',
}

export enum CustomerInfoId {
    WRAPPER = 'fixnet-customer-info',
    CUSTOMER_NAME = 'fixnet-customer-name',
    CUSTOMER_CITY = 'fixnet-customer-city',
    CUSTOMER_STREET = 'fixnet-customer-street',
    CUSTOMER_NUMBER = 'fixnet-customer-number'
}
